import { Component } from '@opten/compiler/metadata/component';
import { EventDispatcher } from '@opten/events/event-dispatcher';
import { toggleClass } from '@opten/dom/toggle-class';

@Component({ className: 'js-form-templates' })
export class FormTemplatesComponent {
	static onFieldAdded = new EventDispatcher<HTMLElement>();
	static onFieldRemoved = new EventDispatcher<HTMLElement>();

	private template: Node;
	private adder: HTMLElement;
	private items: HTMLElement[];
	private namePrefix: string;
	private idPrefix: string;
	private min = 0;
	private max = Number.MAX_SAFE_INTEGER;

	constructor(private element: HTMLElement) {
		const shadow = element.querySelector(
			'.js-form-template-shadow'
		) as HTMLElement;
		const shadowInput = shadow.querySelector('input');
		this.namePrefix = shadowInput.name.substring(
			0,
			shadowInput.name.indexOf('Shadow')
		);
		this.idPrefix = shadowInput.id.substring(
			0,
			shadowInput.id.indexOf('Shadow')
		);
		this.template = shadow
			.querySelector('.js-form-template-item')
			.cloneNode(true);
		shadow.remove();

		this.min = parseInt(element.getAttribute('data-min') || '0');
		this.max = parseInt(element.getAttribute('data-max') || Number.MAX_SAFE_INTEGER.toString());
		this.adder = element.querySelector(
			'.js-form-template-add'
		) as HTMLElement;
		this.items = Array.from(
			this.element.querySelectorAll('.js-form-template-item')
		) as HTMLElement[] || [];

		this.adder.addEventListener('click', (e) => {
			e.preventDefault();
			this.add();
		});

		if (this.items && this.items.length > 0) {
			this.items.forEach((item) => {
				this.initItem(item);
			});
			this.checkRemover();
			this.checkAdder();
		}

		while (!this.items || this.items.length < this.min) {
			this.add();
		}
	}

	add() {
		const newItem = this.template.cloneNode(true);
		const parent =
			this.items && this.items.length > 0
				? this.items[this.items.length - 1].parentNode
				: this.adder.parentNode;
		const newHtmlItem = parent.insertBefore(
			newItem,
			this.items && this.items.length > 0
				? this.items[this.items.length - 1].nextSibling
				: this.adder
		) as HTMLElement;
		const newIndex = this.items.length;
		newHtmlItem.innerHTML = newHtmlItem.innerHTML
			.replaceAll('Shadow_0', `_${newIndex}`)
			.replaceAll('Shadow[0]', `[${newIndex}]`);
		this.items.push(newHtmlItem);
		this.initItem(newHtmlItem);
		this.checkRemover();
		this.checkAdder();
		FormTemplatesComponent.onFieldAdded.dispatch(newHtmlItem);
	}

	remove(item: HTMLElement) {
		this.items.splice(this.items.indexOf(item), 1);
		item.remove();
		this.updateIndex();
		this.checkRemover();
		this.checkAdder();
		FormTemplatesComponent.onFieldRemoved.dispatch(item);
	}

	private initItem(item: HTMLElement) {
		const remover = item.querySelector(
			'.js-form-template-remove'
		) as HTMLElement;
		if (remover) {
			item['Remover'] = remover;
			remover.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.remove(item);
			});
		}
	}

	private updateIndex() {
		if (this.items && this.items.length > 0) {
			this.items.forEach((item, index) => {
				let regExp = new RegExp(
					`${this.escapeRegExp(this.idPrefix)}_\\d+`
				);
				const ids = item.querySelectorAll(`[id^="${this.idPrefix}_"]`);
				ids.forEach((elem) => {
					elem.id = elem.id.replace(
						regExp,
						`${this.idPrefix}_${index}`
					);
				});
				const fors = item.querySelectorAll(
					`[for^="${this.idPrefix}_"]`
				);
				fors.forEach((elem) => {
					elem.setAttribute(
						'for',
						elem
							.getAttribute('for')
							.replace(regExp, `${this.idPrefix}_${index}`)
					);
				});
				const hrefs = item.querySelectorAll(`[href^="#${this.idPrefix}_"]`);
				hrefs.forEach((elem) => {
					elem.setAttribute(
						'href',
						elem.getAttribute('href').replace(
							regExp,
							`${this.idPrefix}_${index}`
						)
					);
				});
				const targets = item.querySelectorAll(`[data-target^="#${this.idPrefix}_"]`);
				targets.forEach((elem) => {
					elem.setAttribute(
						'data-target',
						elem.getAttribute('data-target').replace(
							regExp,
							`${this.idPrefix}_${index}`
						)
					);
				});
				regExp = new RegExp(
					`${this.escapeRegExp(this.namePrefix)}\\[\\d+`
				);
				const names = item.querySelectorAll(
					`[name^="${this.namePrefix}["]`
				);
				names.forEach((elem) => {
					elem.setAttribute(
						'name',
						elem
							.getAttribute('name')
							.replace(regExp, `${this.namePrefix}[${index}`)
					);
				});
			});
		}
	}

	private checkRemover() {
		if (this.min >= 0 && this.items && this.items.length > 0) {
			this.items.forEach((item) => {
				const remover = item['Remover'];
				if (remover) {
					toggleClass(
						remover,
						'd-none',
						this.items.length <= this.min
					);
				}
			});
		}
	}

	private checkAdder() {
		toggleClass(
			this.adder,
			'd-none',
			this.items.length >= this.max
		);
	}

	private escapeRegExp(string) {
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
}
